import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-lg-row flex-column result-buttons column-row-gap-10"
}
const _hoisted_2 = { class: "result-buttons__button-group flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1)
const _hoisted_4 = { class: "result-buttons__button-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1)
const _hoisted_6 = { class: "container px-0 py-9" }
const _hoisted_7 = { class: "full-width flex center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_ComparisonOverviewTableComponent = _resolveComponent("ComparisonOverviewTableComponent")!
  const _component_AcceptModal = _resolveComponent("AcceptModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, null, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "comparison.comparison-overview.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "comparison.comparison-overview.header-description" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  id: "result-export-excel-link",
                  href: "javascript:void(0)",
                  class: "button button-secondary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportComparisonToExcel && _ctx.exportComparisonToExcel(...args))),
                  "data-cy-id": 'klimakompasset-resultat-sammenligninger'
                }, [
                  _hoisted_3,
                  _createVNode(_component_SimpleText, { "text-key": "comparison.excel.button.download-title" })
                ]),
                _createVNode(_component_Tooltip, {
                  style: `vertical-align: middle;`,
                  textKey: 'comparison.download-excel-tooltip',
                  size: "lg"
                }, null, 8, ["textKey"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  id: "comparison-download-pdf-button",
                  class: "button button-secondary flex-grow-equally",
                  role: "button",
                  target: "_blank",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDownloadPdf && _ctx.handleDownloadPdf(...args)), ["prevent"])),
                  onkeydown: "handleKeyDown()",
                  tabindex: "0"
                }, [
                  _hoisted_5,
                  _createVNode(_component_SimpleText, { "text-key": "comparison.pdf.button.download-title" })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h2", _hoisted_7, [
        _createVNode(_component_SimpleText, { "text-key": "comparison.comparison-overview.table-header" })
      ]),
      _createVNode(_component_ComparisonOverviewTableComponent, {
        id: "comparisons",
        ref: "comparisonTable",
        comparisons: _ctx.combinedInfo,
        onDeleteComparison: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteComparison($event))),
        onEditComparison: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editComparison($event)))
      }, null, 8, ["comparisons"])
    ]),
    (_ctx.comparisonToDelete.id && _ctx.comparisonToDelete.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 0,
          "value-object": _ctx.comparisonToDelete,
          "title-key": 'comparison.dialog.delete.title',
          "buttons-disabled": _ctx.disableDeleteModalButtons,
          "button-ok-text-key": 'comparison.dialog.delete.button.ok',
          "button-reject-text-key": 'comparison.dialog.delete.button.cancel',
          onSelectOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteComparison($event))),
          onSelectReject: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetComparisonToDelete()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_SimpleText, { textKey: 'comparison.dialog.delete.text1' }, null, 8, ["textKey"])
              ]),
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.comparisonToDelete.name) + " ", 1),
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_SimpleText, { textKey: 'comparison.dialog.delete.text2' }, null, 8, ["textKey"])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true)
  ], 64))
}